import script from "./itemV3VariantsConf.vue?vue&type=script&setup=true&lang=ts"
export * from "./itemV3VariantsConf.vue?vue&type=script&setup=true&lang=ts"

import "./itemV3VariantsConf.vue?vue&type=style&index=0&id=5783e810&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5783e810"]])

export default __exports__